<template>
  <div
    class="dashboard"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <el-row :gutter="10" v-if="indexType">
      <!-- 左侧 单据入口-->
      <el-col :span="18">
        <BillPage
          ref="billPageRef"
          :indexType="indexType"
          @cancel="cancel"
          @openLoading="openLoading"
        ></BillPage>
      </el-col>
      <!-- 右侧 -->
      <el-col :span="6">
        <DocumentView :indexType="indexType"></DocumentView>
      </el-col>
    </el-row>

    <!-- <ViewFile ref="viewFileRef"></ViewFile> -->
  </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex';
  import BillPage from './homepage/billingPage.vue';
  // import ViewFile from '@/components/business/ViewFile/index.vue';
  import DocumentView from '@/pages/homepage/documentView.vue';
  // import { multimodalTransportProject } from './homepage/data.js';
  // import bus from '../common/js/bus';
  export default {
    name: 'Dashboard',
    data() {
      return {
        tableData: [],
        historyList: [],
        documentList: [],
        loading: true,
        indexType: '',
      };
    },
    mounted() {},
    methods: {
      jumpToHistory() {
        const path = {
          path: 'dashboard/publishHistory',
          name: 'publishHistory',
          meta: {
            keepAlive: true,
            title: '发布历史',
          },
        };
        this.$router.push(path);
      },
      cancel() {
        this.loading = false;
      },
      openLoading() {
        this.loading = true;
      },
    },
    created() {},

    // methods: {},
    computed: {
      ...mapState({
        userInfo: function (state) {
          if (JSON.stringify(state.userInfo.userInfo) == '{}') {
            this.$store.commit('updateUserInfo');
          }
          return state.userInfo;
        },
      }),
      ...mapGetters(['menuIndexType']),
    },
    watch: {
      menuIndexType: {
        handler: function (newVal) {
          console.log(newVal, '监听到的值');
          if (!newVal) {
            (this.indexType = ''), this.cancel();
          } else {
            this.indexType = newVal;
            this.openLoading();
          }
        },
        immediate: true,
      },
    },
    components: {
      BillPage,
      // ViewFile,
      DocumentView,
    },
  };
</script>
<style lang="scss" scoped>
  .icon {
    color: #02a7f0;
    font-size: large;
    font-weight: bold;
    margin-right: 10px;
  }
</style>
